var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-info" },
    [
      _c(
        "div",
        [
          _vm.orderEditType !== 2
            ? _c(
                "el-form",
                {
                  ref: "goodsInfoFilter",
                  attrs: { model: _vm.form, "label-width": "90px" },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "SKU编码", prop: "itemNo" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.itemNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "itemNo", $$v)
                                  },
                                  expression: "form.itemNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "中文品名",
                                prop: "chineseCommodity"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.chineseCommodity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "chineseCommodity", $$v)
                                  },
                                  expression: "form.chineseCommodity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "英文品名",
                                prop: "englishCommodity"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.englishCommodity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "englishCommodity", $$v)
                                  },
                                  expression: "form.englishCommodity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function() {
                                      return _vm.handleQuery(1)
                                    }
                                  }
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [_vm._v("重置")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          { staticClass: "trigger" },
          [
            _c(
              "el-form",
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
                  [_vm._v("新增")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.handleEdit } },
                  [_vm._v("编辑")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.handleDel } },
                  [_vm._v("删除")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { display: "flex", "margin-top": "5px" } },
        [
          _c("cargo-ag-grid", {
            ref: "goodsTable",
            staticStyle: { height: "400px" },
            attrs: {
              "config-module": "700002",
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-form",
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "page-sizes": [10, 20, 30, 50, 100, 200, 500]
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function() {
                    return _vm.handleQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("goods-form", {
        ref: "goodsForm",
        attrs: {
          visible: _vm.visible,
          item: _vm.editRow,
          "edit-sku-no": _vm.editSkuNo
        },
        on: { onSave: _vm.goodsSave, onClose: _vm.handleClose }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }